exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe-card .card-content[data-v-7cf40699] {\n  padding: 15px;\n  height: 80px;\n}\n.recipe-card .card-content h5[data-v-7cf40699] {\n  margin-top: 0;\n}\n.recipe-card .card-content .recipe-detail[data-v-7cf40699] {\n  font-size: 12px;\n  padding: 0 5px;\n  text-align: center;\n}", ""]);

// exports
